<template>
  <div class="documents-report-filters">
    <c-button-2 v-if="open" class="documents-report-filters__toggler" label="Скрыть фильтры" @click="open = false" />

    <transition name="slide">
      <div v-show="open" class="documents-report-filters__slide">
        <div v-if="inited" class="documents-report-filters__wrapper">
          <c-input-2
            v-model="form.filials"
            class="documents-report-filters__item documents-report-filters__filial"
            :type="'select'"
            label="Филиал"
            :checkbox-value="form.filialsExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.filials"
            @checkboxChange="form.filialsExcept = $event"
          />
          <c-input-2
            v-model="form.positions"
            class="documents-report-filters__item documents-report-filters__position"
            :type="'select'"
            label="Должность"
            :checkbox-value="form.positionsExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.positions"
            @checkboxChange="form.positionsExcept = $event"
          />
          <c-input-2
            v-model="form.nameOrPhone"
            class="documents-report-filters__item documents-report-filters__query"
            label="Имя или телефон"
            :clearable="true"
            placeholder="Любые"
            @enter="$emit('apply')"
          />
          <c-input-2
            v-model="form.citizenships"
            class="documents-report-filters__item documents-report-filters__citizenship"
            :type="'select'"
            label="Гражданство"
            :checkbox-value="form.citizenshipsExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.citizenships"
            @checkboxChange="form.citizenshipsExcept = $event"
          />
          <c-input-2
            v-model="form.lawStatuses"
            class="documents-report-filters__item documents-report-filters__law-status"
            :type="'select'"
            label="Правовой статус"
            :checkbox-value="form.lawStatusesExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.lawStatuses"
            @checkboxChange="form.lawStatusesExcept = $event"
          />
          <c-input-2
            v-model="form.workStatuses"
            class="documents-report-filters__item documents-report-filters__work-status"
            :type="'select'"
            label="Статус"
            :checkbox-value="form.workStatusesExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.workStatuses"
            @checkboxChange="form.workStatusesExcept = $event"
          />
          <c-input-2
            v-model="form.docTypes"
            class="documents-report-filters__item documents-report-filters__doc-type"
            :type="'select'"
            label="Тип документа"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.docTypes"
          />
          <c-select
            v-model="form.documents"
            class="documents-report-filters__item documents-report-filters__document"
            type="select"
            label="Наименование документа"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.documents"
            :groups="collections.docTypes"
          />
          <c-input-2
            v-model="form.criticality"
            class="documents-report-filters__item documents-report-filters__criticality"
            :type="'select'"
            label="Критичность документа"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.criticality"
          />
          <c-input-2
            v-model="form.deadlines"
            class="documents-report-filters__item documents-report-filters__deadline"
            :type="'select'"
            label="Срок годности документа"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.deadlines"
          />
          <c-range
            v-model="form.deadlineRange"
            class="documents-report-filters__item range documents-report-filters__deadline-range"
            :max="60"
            :min="0"
            label="Истекает срок годности в течение, дн."
          />
          <c-switcher
            v-model="form.withProblems"
            class="documents-report-filters__item switcher documents-report-filters__problems"
            label="Проблемы с документами"
          />
          <div class="documents-report-filters__item documents-report-filters__actions">
            <c-button size="large" class="documents-report-filters__reset" label="Сбросить" @click="reset" />
            <c-button
              class="documents-report-filters__apply"
              label="Применить"
              color="blue"
              size="large"
              @click="apply"
            />
          </div>
        </div>
      </div>
    </transition>

    <c-button-2 v-if="open" class="documents-report-filters__toggler" label="Скрыть фильтры" @click="open = false" />

    <c-button-2 v-if="!open" class="documents-report-filters__toggler" label="Показать фильтры" @click="open = true" />
  </div>
</template>

<script>
import Input2 from "@/components/controls2/Input";
import Select from "@/components/controls2/Select";
import Button2 from "@/components/controls2/Button";
import Switcher from "@/components/controls/switcher";
import Range from "@/components/controls/range";
import Button from "@/components/controls/button";

const exceptTooltip = {
  disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
  activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
  notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};

export default {
  name: "documents-report-filters",

  components: {
    "c-input-2": Input2,
    "c-select": Select,
    "c-switcher": Switcher,
    "c-range": Range,
    "c-button": Button,
    "c-button-2": Button2,
  },

  data() {
    return {
      inited: false,
      open: false,

      exceptTooltip,
      collections: {
        filials: [],
        positions: [],
        citizenships: [],
        lawStatuses: [],
        workStatuses: [],
        docTypes: [],
        documents: [],
        criticality: [
          { value: "not_required", label: "Необязательный" },
          { value: "required", label: "Обязательный" },
          { value: "critical", label: "Критичный" },
        ],
        deadlines: [
          { value: "without_deadline", label: "Без срока годности" },
          { value: "with_deadline", label: "Со сроком годности" },
          {
            value: "far_from_deadline",
            label: "Далеко до истечения срока годности",
          },
          { value: "expiring", label: "Истекает срок годности" },
          { value: "expired", label: "Истёк срок годности" },
        ],
      },
      form: {
        filials: [],
        filialsExcept: false,
        positions: [],
        positionsExcept: false,
        nameOrPhone: "",
        citizenships: [],
        citizenshipsExcept: false,
        lawStatuses: [],
        lawStatusesExcept: false,
        workStatuses: [],
        workStatusesExcept: false,
        docTypes: [],
        documents: [],
        criticality: [],
        deadlines: [],
        deadlineRange: [0, 0],
        withProblems: false,
      },
    };
  },

  watch: {
    "form.filials": function (v) {
      if (!v.length) {
        this.form.filialsExcept = false;
      }
    },
    "form.positions": function (v) {
      if (!v.length) {
        this.form.positionsExcept = false;
      }
    },
    "form.citizenships": function (v) {
      if (!v.length) {
        this.form.citizenshipsExcept = false;
      }
    },
    "form.lawStatuses": function (v) {
      if (!v.length) {
        this.form.lawStatusesExcept = false;
      }
    },
    "form.workStatuses": function (v) {
      if (!v.length) {
        this.form.workStatusesExcept = false;
      }
    },
  },

  created() {
    Promise.all([
      this.$store
        .dispatch("filters/loadFilials", {
          all: "viewDocumentsReportForAllFilials",
          own: "viewDocumentsReport",
        })
        .then((res) => {
          this.collections.filials = res;
        }),
      this.$store.dispatch("filters/loadPositions").then((res) => {
        this.collections.positions = res;
      }),
      this.$store.dispatch("filters/loadCitizenships").then((res) => {
        this.collections.citizenships = res;
      }),
      this.$store.dispatch("filters/loadLawStatuses").then((res) => {
        this.collections.lawStatuses = res;
      }),
      this.$store.dispatch("filters/loadWorkStatuses").then((res) => {
        this.collections.workStatuses = res;
      }),
      this.$store.dispatch("filters/loadDocuments").then(({ groups, items }) => {
        this.collections.docTypes = groups;
        this.collections.documents = items;
      }),
    ]).then(() => {
      console.log('--->filters promise resolve');
      this.setDefaultParams();
      this.inited = true;
      console.log('--->filters inited', this.inited);
      this.$emit("inited");
    });
  },

  methods: {
    getFilterParams() {
      return {
        deadlineRange: this.form.deadlineRange,
        filials: this.form.filials.map((i) => i.value),
        filialsExcept: this.form.filialsExcept,
        positions: this.form.positions.map((i) => i.value),
        positionsExcept: this.form.positionsExcept,
        citizenships: this.form.citizenships.map((i) => i.value),
        citizenshipsExcept: this.form.citizenshipsExcept,
        lawStatuses: this.form.lawStatuses.map((i) => i.value),
        lawStatusesExcept: this.form.lawStatusesExcept,
        workStatuses: this.form.workStatuses.map((i) => i.value),
        workStatusesExcept: this.form.workStatusesExcept,
        docTypes: this.form.docTypes.map((i) => i.value),
        documents: this.form.documents ? this.form.documents.map((i) => i.value) : [],
        criticality: this.form.criticality.map((i) => i.value),
        deadlines: this.form.deadlines.map((i) => i.value),
        nameOrPhone: this.form.nameOrPhone.trim(),
        withProblems: this.form.withProblems,
      };
    },

    getParams() {
      const filters = this.getFilterParams();

      const params = {
        deadline_range: {
          start: filters.deadlineRange[0],
          finish: filters.deadlineRange[1],
        },
      };

      if (filters.filials.length) {
        params.filials = {
          values: filters.filials.join(","),
          search_type: filters.filialsExcept ? 2 : 1,
        };
      }
      if (filters.positions.length) {
        params.posts = {
          values: filters.positions.join(","),
          search_type: filters.positionsExcept ? 2 : 1,
        };
      }
      if (filters.citizenships.length) {
        params.citizenship = {
          values: filters.citizenships.join(","),
          search_type: filters.citizenshipsExcept ? 2 : 1,
        };
      }
      if (filters.lawStatuses.length) {
        params.lawStatus = {
          values: filters.lawStatuses.join(","),
          search_type: filters.lawStatusesExcept ? 2 : 1,
        };
      }
      if (filters.workStatuses.length) {
        params.workStatus = {
          values: filters.workStatuses.join(","),
          search_type: filters.workStatusesExcept ? 2 : 1,
        };
      }
      if (filters.docTypes.length) {
        params.docGroupId = {
          values: JSON.stringify(filters.docTypes),
        };
      }
      if (filters.documents.length) {
        params.typeDocId = {
          values: filters.documents.join(","),
        };
      }
      if (filters.criticality.length) {
        params.criticality = {
          values: JSON.stringify(filters.criticality),
        };
      }
      if (filters.deadlines.length) {
        params.deadlines = {
          values: JSON.stringify(filters.deadlines),
        };
      }

      if (filters.nameOrPhone) {
        params.nameOrPhone = {
          value: filters.nameOrPhone,
        };
      }

      if (filters.withProblems) {
        params.problems_exist = 1;
      }

      return params;
    },

    saveParams() {
      const filters = this.getFilterParams();
      const query = {
        ...this.$route.query,

        deadlineRange: filters.deadlineRange.join(","),
        filials: filters.filials.join(","),
        filialsExcept: filters.filialsExcept ? 1 : 0,
        positions: filters.positions.join(","),
        positionsExcept: filters.positionsExcept ? 1 : 0,
        citizenships: filters.citizenships.join(","),
        citizenshipsExcept: filters.citizenshipsExcept ? 1 : 0,
        lawStatuses: filters.lawStatuses.join(","),
        lawStatusesExcept: filters.lawStatusesExcept ? 1 : 0,
        workStatuses: filters.workStatuses.join(","),
        workStatusesExcept: filters.workStatusesExcept ? 1 : 0,
        docTypes: filters.docTypes.join(","),
        documents: filters.documents.join(","),
        criticality: filters.criticality.join(","),
        deadlines: filters.deadlines.join(","),
        nameOrPhone: filters.nameOrPhone,
        withProblems: filters.withProblems ? 1 : 0,
      };

      this.$router
        .replace({
          name: "documents-report",
          query,
        })
        .catch(() => {});
    },

    setDefaultParams() {
      const sp = this.$route.query;

      if (sp.deadlineRange) {
        this.form.deadlineRange = sp.deadlineRange.split(",");
      }

      if (sp.filials) {
        const collection = this.collections.filials;
        this.form.filials = sp.filials
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);

        this.form.filialsExcept = sp.filialsExcept === "1";
      }

      if (sp.positions) {
        const collection = this.collections.positions;
        this.form.positions = sp.positions
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);

        this.form.positionsExcept = sp.positionsExcept === "1";
      }

      if (sp.citizenships) {
        const collection = this.collections.citizenships;
        this.form.citizenships = sp.citizenships
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);

        this.form.citizenshipsExcept = sp.citizenshipsExcept === "1";
      }

      if (sp.lawStatuses) {
        const collection = this.collections.lawStatuses;
        this.form.lawStatuses = sp.lawStatuses
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);

        this.form.lawStatusesExcept = sp.lawStatusesExcept === "1";
      }

      if (sp.workStatuses) {
        const collection = this.collections.workStatuses;
        this.form.workStatuses = sp.workStatuses
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);

        this.form.workStatusesExcept = sp.workStatusesExcept === "1";
      }

      if (sp.docTypes) {
        const collection = this.collections.docTypes;
        this.form.docTypes = sp.docTypes
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);
      }

      if (sp.documents) {
        const collection = this.collections.documents;
        this.form.documents = sp.documents
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);
      }

      if (sp.criticality) {
        const collection = this.collections.criticality;
        this.form.criticality = sp.criticality
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);
      }

      if (sp.deadlines) {
        const collection = this.collections.deadlines;
        this.form.deadlines = sp.deadlines
          .split(",")
          .map((itemId) => collection.find((i) => i.value.toString() === itemId.toString()))
          .filter(Boolean);
      }

      if (sp.nameOrPhone) {
        this.form.nameOrPhone = sp.nameOrPhone;
      }

      if (sp.withProblems) {
        this.form.withProblems = sp.withProblems === "1";
      }
    },

    reset() {
      this.form.filials = [];
      this.form.filialsExcept = false;
      this.form.positions = [];
      this.form.positionsExcept = false;
      this.form.nameOrPhone = "";
      this.form.citizenships = [];
      this.form.citizenshipsExcept = false;
      this.form.lawStatuses = [];
      this.form.lawStatusesExcept = false;
      this.form.workStatuses = [];
      this.form.workStatusesExcept = false;
      this.form.docTypes = [];
      this.form.documents = [];
      this.form.criticality = [];
      this.form.deadlines = [];
      this.form.deadlineRange = [0, 0];
      this.form.withProblems = false;

      this.apply();
    },

    apply() {
      this.saveParams();
      this.$emit("apply");
    },
    "form.lawStatuses"(v) {
      if (!v.length) {
        this.form.lawStatusesExcept = false;
      }
    },
    "form.workStatuses"(v) {
      if (!v.length) {
        this.form.workStatusesExcept = false;
      }
    },    
  }
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
